<template>
    <div>
        <h3 class="mb-3 mt-2">Vehicle Type DropDown</h3>
        <vx-card noShadow noRound>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <vs-input
                        v-model="vehicle_type.name"
                        label="Name"
                        class="w-full"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.name">
                        {{ api_errors.name.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <InputSelect
                        :model.sync="vehicle_type.issue_type_category"
                        label="Issue Type Category"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="issue_type_category_options"
                        :multiple="false"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.issue_type_category">
                        {{ api_errors.issue_type_category.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block">Is Active</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio v-model="vehicle_type.active" vs-name="active" :vs-value="true">Yes</vs-radio>
                        <vs-radio v-model="vehicle_type.active" vs-name="active" :vs-value="false" class="mx-3">No</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.active">
                        {{ api_errors.active.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
            <vs-row class="mt-base">
                <vs-col class="text-center">
                    <vs-button @click="save" :disabled="submit_disabled">
                        Save
                    </vs-button>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>

<script>
import { Request } from '../../../utils/requests'

export default {
    data() {
        return {
            vehicle_type_id: this.$route.params.vehicle_type_id,

            vehicle_type: {
                name: null,
                active: true,
                issue_type_category: null
            },

            issue_type_category_options: [
                {value: 'incident', label: "Incident"},
                {value: 'vehicle_breakdown', label: "Vehicle Breakdown"},
                {value: 'unauthorised_parking', label: "Unauthorised Parking"},
                {value: 'traffic_violation', label: "Traffic Violation"},
                {value: 'road_user_accident', label: "Road User Accident"},
            ],

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.vehicle_type_id"(newV, oldV) {
            if (newV == oldV) return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.vehicle_type_id = this.$route.params.vehicle_type_id

            if (this.vehicle_type_id) this.load_data()
            else this.vehicle_type = {
                name: null,
                active: true,
                issue_type_category: null
            }
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.vehicle_type_get + this.vehicle_type_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.vehicle_type = res
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.vehicle_type_get
            if (this.vehicle_type_id) {
                request_method = 'PUT'
                url += this.vehicle_type_id + '/'
            }

            let payload = this.vehicle_type

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.submit_disabled = false
                    this.vehicle_type = res
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'vehicle-type-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        }
    }
}
</script>